module.exports = __webpack_public_path__ + "static/customer-9246323fa76269c69ec6896f0a9d128f.png";